module.exports = __webpack_public_path__ + "static/media/type.1a0c30f5.svg";